import React from "react";
import { motion } from "framer-motion";

interface NavigationDotsProps {
  currentSection: number;
  isScrollLocked: boolean;
  onSectionChange: (index: number) => void;
  totalSections: number;
}

const NavigationDots = ({
  currentSection,
  isScrollLocked,
  onSectionChange,
  totalSections,
}: NavigationDotsProps) => {
  if (totalSections === 0) return null;

  return (
    <div className="flex justify-center mt-12 md:mt-16 space-x-3">
      {Array.from({ length: totalSections }).map((_, index) => (
        <motion.button
          key={index}
          className={`w-3 h-3 rounded-full transition-all duration-300 ${
            index === currentSection
              ? "bg-blue-500 scale-125"
              : "bg-gray-300 hover:bg-gray-400"
          }`}
          onClick={() => !isScrollLocked && onSectionChange(index)}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
          disabled={isScrollLocked}
        />
      ))}
    </div>
  );
};

export default NavigationDots;
